import { render, staticRenderFns } from "./WebpartTemplate.vue?vue&type=template&id=91b1805a&scoped=true"
import script from "./WebpartTemplate.vue?vue&type=script&lang=ts"
export * from "./WebpartTemplate.vue?vue&type=script&lang=ts"
import style0 from "./WebpartTemplate.vue?vue&type=style&index=0&id=91b1805a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b1805a",
  null
  
)

export default component.exports